import { Box, Button, Card, CardContent, Grid, IconButton, InputAdornment, InputLabel, Table, TableBody, TableCell, tableCellClasses, TableRow, TextField, Typography } from "@mui/material";
import Layout from "./Layout";
import { styled } from "@mui/material/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { agentActions } from "../store/actions";
import { useLocation, useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)((sx) => ({
    [`&.${tableCellClasses.body}`]: {
        fontFamily: 'Inter, sans-serif',
        fontSize: "0.9rem",
        border: "none",
        fontWeight: "600",
        padding: "12px"
    },
    "&:nth-of-type(odd)": {
        fontWeight: "300"
    }
}));

const FormInputField = ({label, id, InputProps, onChange, type='text'}) => (
    <Grid item sm={6}>
        <InputLabel htmlFor={id} sx={{ color: "#222", mb: '1rem' }}>{label}</InputLabel>
        <TextField
        onChange={onChange}
        id={id}
        type={type}
        fullWidth
        size="small"
        placeholder={label}
        InputProps={InputProps}
        sx={{
            "& .MuiOutlinedInput-root": {
                "& fieldset": {
                    borderColor: "#000"
                },
                "&:hover fieldset": {
                    borderColor: "#000"
                },
                "&.Mui-focused fieldset": {
                    borderWidth: "1px",
                    borderColor: "#000"
                }
            }
        }}
        />
    </Grid>
)

const MasterAgentForm = ({
    setFullname,
    setUsername,
    setPassword,
    setPhoneno,
    onChangeHandler
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    }

    return (
        <Grid container spacing={2} sx={{ mt: '1rem' }}>
            <FormInputField onChange={(e)=>onChangeHandler(setFullname, e)} label="Name" id="name"/>
            <FormInputField onChange={(e)=>onChangeHandler(setUsername, e)} label="Username" id="username"/>
            <FormInputField onChange={(e)=>onChangeHandler(setPassword, e)} label="Password" id="password"
            type={showPassword? 'text': 'password'}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                        onClick={handleShowPassword}>
                            {showPassword? <Visibility/> : <VisibilityOff/>}
                        </IconButton>
                    </InputAdornment>
                )
            }}/>
            <FormInputField onChange={(e)=>onChangeHandler(setPhoneno, e)} label="Phone Number" id="phoneno"/>
        </Grid>
    )
}

const InformationCard = ({name}) => (
    <Card variant="outlined" sx={{
        border: 'none',
        backgroundColor: "#F3F3F3",
        borderRadius: '12px'
    }}>
        <CardContent>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell>Created by</StyledTableCell>
                        <StyledTableCell>{name?? "Loading"}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell>Created on</StyledTableCell>
                        <StyledTableCell>{new Date().getDate()+"."+new Date().getMonth()+"."+new Date().getFullYear()}</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell>Updated by</StyledTableCell>
                        <StyledTableCell>-</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell>Updated on</StyledTableCell>
                        <StyledTableCell>-</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell>Deleted by</StyledTableCell>
                        <StyledTableCell>-</StyledTableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell>Deleted on</StyledTableCell>
                        <StyledTableCell>-</StyledTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </CardContent>
    </Card>
)

export default function NewPlayerForm() {

    const { name } = useSelector((state) => state.auth.agent);
    const [fullname, setFullname] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [phoneno, setPhoneno] = useState("");
    const [isFormValid, setIsFormValid] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const validateForm = () => {
        // console.log(fullname.trim()=="", username=="", password=="", phoneno=="", commission=="", multiplier2d=="", multiplier3d=="");
        if (fullname.trim() != "" && username.trim() != "" && password.trim() != "" && phoneno.trim() != "") {
            setIsFormValid(true);
        } else {
            setIsFormValid(false);
        }
    }

    const onChangeHandler = (handler, e) => {
        if (e.target.value.trim == "") {
            setIsFormValid(false);
        }
        handler(e.target.value);
    }

    useEffect(() => {
        validateForm();
    }, [fullname, username, password, phoneno]);

    const createHandler = async () => {
        if (!isFormValid) return;
        let data = {
            name: fullname,
            username,
            password,
            phoneno,
        }
        await dispatch(agentActions.createPlayer(data));
        navigate("/players");
    }

    return (
        <Layout>
            <Typography variant="h5">Create New Player</Typography>
            <Grid
            container
            direction="row"
            spacing={4}
            sx={{
                height: '100%'
            }}
            >
                <Grid
                sm={8.5}
                item
                sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: "space-between",
                    pr: '2rem',
                    borderRight: "1px solid rgba(0,0,0,0.12)",
                }}
                >
                    <Box>
                        <Typography variant="body1" sx={{ opacity: "45%", mt: "1.5rem", fontSize: "15px" }}>Player Info</Typography>
                        <Grid container sx={{ mt: "0.1rem" }} spacing={2}>
                            <Grid item>
                                <Typography sx={{ opacity: "60%", fontSize: "15px" }}>Type:</Typography>
                            </Grid>
                            <Grid item>
                                <Typography sx={{ fontSize: "15px" }}>Player</Typography>
                            </Grid>
                        </Grid>
                        <MasterAgentForm
                            setFullname={setFullname}
                            setUsername={setUsername}
                            setPassword={setPassword}
                            setPhoneno={setPhoneno}
                            onChangeHandler={onChangeHandler}
                        />
                    </Box>
                    <Grid container justifyContent="flex-end">
                        <Grid item sm={6} container spacing={2}>
                            <Grid item sm={6}>
                                <Button size='large' fullWidth variant="contained"
                                sx={{
                                    backgroundColor: "#F5F5F5",
                                    color: "rgba(0,0,0,0.4)",
                                    fontWeight: "600",
                                    "&:hover": {
                                        boxShadow: "none",
                                        backgroundColor: "#F5F5F5"
                                    }
                                }}>
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item sm={6}>
                                <Button size='large' fullWidth variant="contained"
                                onClick={createHandler}
                                sx={{
                                    fontWeight: "600"
                                }}>
                                    Create
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={3.5}>
                    <InformationCard name={name}/>
                </Grid>
            </Grid>
        </Layout>
    )
}